import { useState } from 'react';
import {
    Box,
    Typography,
    TextField,
    FormControlLabel,
    Switch,
    Button,
    Grid,
    InputAdornment,
    IconButton,
    MenuItem,
    Select,
    FormControl,
    InputLabel
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

function ProxyConfigSection({ config, onChange, onSave, hasChanges, localisation }) {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <Box sx={{ textAlign: 'left' }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 3, fontWeight: 500 }}>
                Proxy Settings
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={config.proxy_required || false}
                                onChange={(e) => onChange('proxy_required', e.target.checked)}
                            />
                        }
                        label="Use Proxy Server"
                    />
                </Grid>

                {config.proxy_required && (
                    <>
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Protocol</InputLabel>
                                <Select
                                    value={config.proxy_protocol || 'http'}
                                    label="Protocol"
                                    onChange={(e) => onChange('proxy_protocol', e.target.value)}
                                >
                                    <MenuItem value="http">HTTP</MenuItem>
                                    <MenuItem value="https">HTTPS</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Proxy Host"
                                value={config.proxy_host || ''}
                                onChange={(e) => onChange('proxy_host', e.target.value)}
                                autoComplete="off"
                                inputProps={{ autoComplete: 'off', 'data-form-type': 'other' }}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Proxy Port"
                                value={config.proxy_port || ''}
                                onChange={(e) => onChange('proxy_port', e.target.value)}
                                autoComplete="off"
                                inputProps={{ autoComplete: 'off', 'data-form-type': 'other' }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Proxy Username"
                                value={config.proxy_user || ''}
                                onChange={(e) => onChange('proxy_user', e.target.value)}
                                autoComplete="new-password"
                                inputProps={{ autoComplete: 'new-password', 'data-form-type': 'other' }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Proxy Password"
                                type={showPassword ? 'text' : 'password'}
                                value={config.proxy_password || ''}
                                onChange={(e) => onChange('proxy_password', e.target.value)}
                                autoComplete="new-password"
                                inputProps={{ autoComplete: 'new-password', 'data-form-type': 'other' }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setShowPassword(!showPassword)}
                                                edge="end"
                                                size="small"
                                            >
                                                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                    </>
                )}
            </Grid>

            <Button
                variant="contained"
                color="primary"
                onClick={onSave}
                disabled={!hasChanges}
                sx={{ mt: 3 }}
            >
                {localisation?.["save_button"]?.element_lang || "Save"}
            </Button>
        </Box>
    );
}

export default ProxyConfigSection;
